import React from "react";

// Circular gold-ring badge with the flowing golden wing, matching the original brand mark.
export function Logo({ size = "md", dark = true }) {
  const badge = size === "lg" ? "h-14 w-14" : "h-10 w-10";
  const title = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div
        className={`${badge} rounded-full shrink-0 flex items-center justify-center relative`}
        style={{
          background: "radial-gradient(circle at 50% 40%, #0d1830 0%, #050b18 100%)",
          boxShadow: "0 0 0 2px #050b18, 0 0 0 3.5px #F5A623, 0 4px 14px rgba(0,0,0,.35)",
        }}
      >
        <svg viewBox="0 0 64 64" className="h-[68%] w-[68%]" aria-hidden="true">
          <defs>
            <linearGradient id="wingGold" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#FDE68A" />
              <stop offset="45%" stopColor="#F5A623" />
              <stop offset="100%" stopColor="#B45309" />
            </linearGradient>
          </defs>
          <g fill="url(#wingGold)">
            {/* top curl of the wing */}
            <path d="M40 15c6 1 11 5 12 11-4-3-8-4-12-3 3-4 2-6 0-8z" />
            {/* long sweeping feathers */}
            <path d="M8 40c14-1 26-5 40-19-3 9-9 15-17 19 8-1 14-3 21-9-4 9-12 15-24 16-8 .7-15 .3-20-.3 0-2 0-4 0-6z" />
            <path d="M12 46c10 0 19-2 29-9-5 6-11 9-18 11 5 0 9-1 14-4-4 6-11 8-19 9-4 .4-8 .2-11 0 1-3 3-5 5-7z" />
            {/* underline stroke */}
            <path d="M10 53c11 1 22 .6 33-3-8 5-17 7-27 7-3 0-6-.2-9-.6 1-1.2 2-2.4 3-3.4z" opacity=".85" />
          </g>
        </svg>
      </div>
      <div className="leading-none">
        <div className={`${title} font-extrabold font-display brand-gold-text`}>Pya'elino</div>
        <div className={`text-[10px] font-bold tracking-[0.35em] ${dark ? "text-slate-300" : "text-slate-500"}`}>COURIER</div>
      </div>
    </div>
  );
}
